import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';

export default class DosageHold extends BackboneElement {
    static __className = 'DosageHold';

    __objectStructure = {
        reason: CodeableConcept,
        notes: String,
    };

    constructor(constructJson, className = 'DosageHold') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
